<template>
    <div class="templete">
        <div class="search_box search_box_f clearfix">
            <div class="group">
                <div :class="['item', item.show ? 'checked': '' ]" v-for="(item) in keyList" :key="item.key" @click="check(item)">
                    {{ item.name }}
                </div>
                <el-checkbox class="check_all_item" v-model="is_all" @change="checkAll($event)">全选</el-checkbox>
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="tableBox">
            <tabletem :isSetCol="true" scene="report.inventory.custom" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list"></tabletem>
        </div>
        <div class="text-center">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <div class="totalCal">
            <div class="totalName">合计：</div>
            <div class="totalNumber">件数:{{ statistics.count }}件</div>
            <div class="totalNumber">方数：{{ statistics.sales_cube }}m³</div>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="report.inventory.custom" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2; overflow: auto;
    }
    .group{
        display: flex; flex-wrap: wrap;
        .item{ min-width:85px; height:36px; line-height: 32px; text-align: center; padding: 0 12px; border-radius:3px; border:1px solid rgba(102,102,102,1); cursor: pointer; margin: 6px; }
        .item.checked{
            border:1px solid rgba(178,17,17,1); position: relative; color: #B21111;
            &::after{ display: block; content: ""; width:21px; height:21px; position: absolute; right: 0; bottom: 0; background: url("/icon/checkeded.png") no-repeat; background-size: cover; }
        }
        .check_all_item{ height:36px; line-height: 36px; text-align: center; margin: 6px; }
    }
</style>
<script>
import tabletem from '../../../components/table.vue'
import pagination from '../../../components/pagination.vue'
    export default {
        components:{
            tabletem,
            pagination
        },
        data(){
            return{
                tableLoading:false,
                params : {
                    page : 1,
                    per_page : 50,
                    field_list : [],
                    default:1
                },
                keyList : [],
                is_all : true,
                last_page : 1,
                current_page : 1,
                total:0,
                statistics : {
                    count  : "",
                    sales_cube  : "",
                },

                brandList : [],
                breedList : [],
                gradeList : [],
                warehouseList : [],
                supplierList : [],


                list:[],
                tableCol:[
                    {colName:"品名",colKey:"breed",colWidth:105,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"等级",colKey:"grade",colWidth:75,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"厚度(cm)",colKey:"sales_thickness",colWidth:74,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"长度(m)",colKey:"sales_length",colWidth:71,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:143,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:145,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"货柜号",colKey:"container_no",colWidth:81,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"订单量(m³)",colKey:"order_cube",colWidth:129,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"在途量(m³)",colKey:"road_cube",colWidth:129,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"库存量(m³)",colKey:"inventory_cube",colWidth:129,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:116,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"船名",colKey:"ship_no",colWidth:129,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"批次",colKey:"batch_no",colWidth:129,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"堆号",colKey:"heap_no",colWidth:129,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"材种类型",colKey:"category",colWidth:129,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},

                    // {colName:"件数",colKey:"count",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"方数",colKey:"sales_cube",colWidth:93,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"货物状态",colKey:"",colWidth:116,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                filterDialogVisible:false,
                filter:"",
                fields:"",
            }
        },
        methods:{
            check(row){
                let flag = true;
                this.keyList.forEach((item,index)=>{
                    if(item.field==row.field){
                        this.keyList[index].show = !item.show;
                        if(this.keyList[index].show){
                            this.fields = this.fields + this.keyList[index].field + ",";
                        }else{
                            let fil = this.keyList[index].field+",";
                            this.fields = this.fields.replace(fil,"")
                        }
                    }
                    if(!item.show){
                        flag = false;
                    }
                })
                if(flag){
                    this.is_all = true;
                }else{
                    this.is_all = false;
                }
                this.tableCol.forEach((item,index)=>{
                    if(this.fields.indexOf(","+item.colKey+",")!=-1){
                        this.tableCol[index].isShow=true;
                    }else{
                        this.tableCol[index].isShow=false;
                    }
                })
                this.params.page = 1;
                this.getList()
            },
            checkAll(value){
                this.pl(this.keyList)
                this.keyList.forEach((item,index)=>{
                    this.keyList[index].show = value;
                })
                this.fields = ",inventory_cube,order_cube,road_cube,";
                if(value){
                    this.keyList.forEach(item=>{
                        this.fields += item.field+",";
                    })
                }
                this.tableCol.forEach((item,index)=>{
                    if(this.fields.indexOf(","+item.colKey+",")!=-1){
                        this.tableCol[index].isShow=true;
                    }else{
                        this.tableCol[index].isShow=false;
                    }
                })
                this.params.page = 1;
                this.getList()
            },
            exportExcelBill(){
                let arr = new Array();
                this.keyList.forEach(item=>{
                    if(item.show){
                        arr.push(item.field)
                    }
                })
                this.$exportExecl("/erp/export.inventory.custom","自定义汇总表",{field_list:arr})
            },
            filterConfirm(){
                this.getList()
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            getList(){
                this.tableColCopy = this.$deepClone(this.tableCol);
                this.params.field_list = [];
                this.fields.split(",").forEach(item=>{
                    if(item!=''){
                        this.params.field_list.push(item)
                    }
                })
                this.tableLoading = true;
                this.$postColumnList("/erp/report.inventory.custom",this.params,response=>{
                    if(response.data.code == 0){
                        this.list = response.data.data.data;
                        this.total = response.data.data.total;
                        this.statistics = response.data.data.statistics;
                        this.last_page = response.data.data.last_page;
                        this.$refs.pagination.flag = true;
                        this.tableLoading = false;
                        this.fields = "";
                        this.fields=",inventory_cube,order_cube,road_cube,";
                        response.data.data.fields.forEach(item=>{
                            this.fields += item+","
                        })
                        this.filter = response.data.data.column;
                        let arr = new Array()
                        let col = JSON.parse(JSON.stringify(response.data.data.column))
                        col.forEach(item=>{
                            if(item.show){
                                if(this.params.default==0){
                                    if(this.fields.indexOf(","+item.field+",")==-1){
                                        item.show = false;
                                    }
                                }
                                arr.push(item)
                            }
                        })
                        this.keyList = arr;
                        this.tableCol.forEach(item=>{
                            if(this.fields.indexOf(","+item.colKey+",")!=-1){
                                item.isShow=true;
                            }else{
                                item.isShow=false;
                            }
                        })
                        this.params.default = 0;
                    }
                })
            },
            search(){
                if(this.params.page == 1){
                    this.getList();
                } else {
                    this.params.page = 1
                }
            },
            reset(){
                this.start_time = "";
                this.end_time = "";
                this.params.search = {
                    breed_id : "",
                    brand_id : "",
                    grade_id : "",
                    sales_thickness : "",
                    sales_length : "",
                    warehouse_id : "",
                    container_no : ""
                }
                this.getList();
            },
            // 品名
            getBreedList(visible){
                if(visible){
                    this.$getBreedList().then(res=>{
                        this.breedList = res.data.data;
                    })
                }
            },
            // 品牌
            getBrandList(visible){
                if(visible){
                    this.$getBrandList().then(res=>{
                        this.brandList = res.data.data;
                    })
                }
            },
            // 等级
            getGradeList(visible){
                if(visible){
                    this.$getGradeList().then(res=>{
                        this.gradeList = res.data.data;
                    })
                }
            },
            // 仓库
            getWarehouseListList(visible){
                if(visible){
                    this.$getWarehouseList().then(res=>{
                        this.warehouseList = res.data.data;
                    })
                }
            },
            // 供应商
            getSupplierList(visible){
                if(visible){
                    this.$getSupplierList().then(res=>{
                        this.supplierList = res.data.data;
                    })
                }
            },

        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.search();
            }
        }
    }
</script>
